import { StatusAlertType } from '../ThemeProvider/types';

export interface AlertsProps {}

export const INFO_ALERT = 'info';
export const ERROR_ALERT = 'error';
export const SUCCESS_ALERT = 'success';
export const WARNING_ALERT = 'warning';

export interface AlertData {
  type: StatusAlertType;
  title: string;
  onConfirmLabel?: string;
  onCancelLabel?: string;
  subMessage?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  testId?: string;
  isMobile?: boolean;
  closeOnBlur?: boolean;
  closeButton?: boolean;
}

export type AlertButtonColors =
  | typeof INFO_ALERT
  | typeof ERROR_ALERT
  | typeof WARNING_ALERT
  | typeof SUCCESS_ALERT;

export interface TypeAlert {
  [key: string]: StatusAlertType;
}

export const AlertStatus: TypeAlert = {
  [INFO_ALERT]: 'info',
  [ERROR_ALERT]: 'error',
  [SUCCESS_ALERT]: 'success',
  [WARNING_ALERT]: 'warning',
};
